export const Types = {
    DOWNLOAD_SCHEMA: "DOWNLOAD_SCHEMA",
    DOWNLOAD_EXAMPLES: "DOWNLOAD_EXAMPLES",
    EXCEL_TO_LIST_SINGLE_MAINTENANCE: "EXCEL_TO_LIST_SINGLE_MAINTENANCE",
    UPLOAD_EXCEL: "UPLOAD_EXCEL",
    UPLOAD_EXCEL_FILE_RESPONSE: "UPLOAD_EXCEL_FILE_RESPONSE"
};

//download schema
export const downloadSchema = () => ({
    type: Types.DOWNLOAD_SCHEMA,
});

export const downloadExamples = (payload) => ({
    type: Types.DOWNLOAD_EXAMPLES,
    payload
});
export const uploadExcel = (payload) => ({
    type: Types.UPLOAD_EXCEL,
    payload
});

export const excelToListSingle = (payload) => (
    {
    type: Types.EXCEL_TO_LIST_SINGLE_MAINTENANCE,
    payload,
    
});

export const uploadExcelFileResponse = (payload) => ({
    type: Types.UPLOAD_EXCEL_FILE_RESPONSE,
    payload: payload
});

